import React from "react";
import { useMediaQuery } from "@mui/material";
import clsx from "clsx";
import style from "./style.module.scss";
import {
  ArrowBack as ArrowLeft,
  ArrowForward as ArrowRight,
} from "@mui/icons-material";

export const Pagination = ({
  currentPagination,
  numberOfPages,
  setCurrentPage,
}) => {
  const isDesktop = useMediaQuery("(min-width:" + style.tabletBreakpoint + ")");
  const maxElementPagination = isDesktop ? 6 : 4;
  // React i18next

  let firstElement =
    numberOfPages - currentPagination >= maxElementPagination - 2
      ? currentPagination - 2
      : numberOfPages - maxElementPagination;
  if (firstElement < 0) {
    firstElement = 0;
  }

  let pagination = [...Array(numberOfPages)].slice(
    firstElement,
    firstElement + maxElementPagination
  );

  return (
    <div className={style.pagination}>
      <div
        className={clsx(style.button, currentPagination === 1 && style.disable)}
        onClick={() => setCurrentPage(currentPagination - 1)}
      >
        <ArrowLeft />
      </div>

      {pagination.map((x, i) => (
        <div
          key={i}
          className={clsx(
            currentPagination === i + 1 + firstElement && style.currentPage
          )}
          onClick={() => setCurrentPage(i + 1 + firstElement)}
        >
          {i + 1 + firstElement}
        </div>
      ))}

      <div
        className={clsx(
          style.button,
          currentPagination === numberOfPages && style.disable
        )}
        onClick={() => setCurrentPage(currentPagination + 1)}
      >
        <ArrowRight />
      </div>
    </div>
  );
};

export default Pagination;
